// @flow
import * as React from 'react'
import { FormattedMessage } from 'mz-intl'
import getAirports from 'mz-sdk/services/places/getAirports'
import type { SuggestionLocation } from 'mz-sdk/models/location'
import messages from './messages.intl'
import EmptySearchResults from '../SelectField/EmptySearchResults'
import SelectField from '../SelectField'

// Types
import type { Props as SelectFieldProps } from '../SelectField'

export type Props = SelectFieldProps

/**
 * A field to select airport object.
 */
class AirportField extends React.Component<Props> {
  static defaultProps = SelectField.defaultProps

  requestPlaces = (query: string): Promise<Array<SuggestionLocation>> => {
    if (!query || query.length < 3) return Promise.resolve([])
    return getAirports(query)
  }

  renderPlaceToString = (place: SuggestionLocation) => place.display

  renderEmpty = (query: string) => {
    if (!query || query.length < 3) return null
    return (
      <EmptySearchResults
        query={query}
        emptyResultsMessage={
          <FormattedMessage
            message={messages.NO_PLACE_FOUND}
            values={{ query: <b>{query}</b> }}
          />
        }
      />
    )
  }

  render() {
    const { placeholder, label } = this.props
    return (
      <SelectField
        emptyValue={null}
        {...this.props}
        label={label || <FormattedMessage message={messages.LABEL} />}
        placeholder={
          placeholder || <FormattedMessage message={messages.PLACEHOLDER} />
        }
        searchableOptions={{
          ...this.props.searchableOptions,
          requestOptions: this.requestPlaces,
          renderEmpty: this.renderEmpty,
        }}
        renderValue={this.renderPlaceToString}
        renderOption={this.renderPlaceToString}
      />
    )
  }
}

export default AirportField
